import { Label } from "layout/typography/Label";
import { Checkbox } from "primereact/checkbox";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

import {
  MpdrDuplicateCptExample,
  MpdrDuplicateState,
} from "./MpdrDuplicateCptExamples";

const Title = styled.h3`
  margin-bottom: 16px;
`;

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  &:not(:first-of-type) {
    margin-top: 0.75rem;
  }
`;

/**
 * MPDR duplicate-CPT controls. Two mutually-exclusive flags + an inline worked
 * example that updates based on which is checked (or neither). CLE-2315.
 */
export function AllowDuplicateCptCodes() {
  const { control, watch, setValue } = useFormContext<any>();
  const allowOnDuplicate = !!watch("allowOnDuplicateCptCodes");
  const duplicateNotPaid = !!watch("duplicateNotPaid");

  // Mutual exclusion: turning one on turns the other off. duplicateNotPaid wins
  // server-side too if both are accidentally set; the UI prevents that by design.
  let state: MpdrDuplicateState;
  if (duplicateNotPaid) {
    state = "DUPLICATE_NOT_PAID";
  } else if (allowOnDuplicate) {
    state = "ALLOW_DUPLICATE";
  } else {
    state = "NEITHER";
  }

  return (
    <div className="block bg-white border-round p-4 mb-4">
      <Title>Rule</Title>

      <CheckboxRow>
        <Controller
          name="allowOnDuplicateCptCodes"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              inputId="allowOnDuplicateCptCodes"
              onChange={(e) => {
                onChange(e);
                // Clear the mutually-exclusive sibling.
                if (e.checked) setValue("duplicateNotPaid", false);
              }}
              checked={!!value}
            />
          )}
        />
        <Label htmlFor="allowOnDuplicateCptCodes">
          Allow Duplicate CPT codes
        </Label>
      </CheckboxRow>

      <CheckboxRow>
        <Controller
          name="duplicateNotPaid"
          control={control}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              inputId="duplicateNotPaid"
              onChange={(e) => {
                onChange(e);
                if (e.checked) setValue("allowOnDuplicateCptCodes", false);
              }}
              checked={!!value}
            />
          )}
        />
        <Label htmlFor="duplicateNotPaid">Duplicate Not Paid</Label>
      </CheckboxRow>

      <MpdrDuplicateCptExample state={state} />
    </div>
  );
}
